/*
 * <cart-attribute>
 *
 * Persists a single cart field to the cart via /cart/update.js as the shopper
 * types, mirroring Dawn's <cart-note> pattern so the value survives drawer
 * re-renders and lands on the order. Wrap a single input/textarea whose name is
 * either `attributes[<Attribute name>]` (saved as a cart attribute) or `note`
 * (saved as the cart note, which becomes the order note).
 *
 * Used for the "Free personalised gift message" field in the cart drawer and on
 * /cart. Since 2026-09-21 that field is `name="note"`: ShipStation prints the
 * order note on the packing slip (Notes from Buyer), and it appends every order
 * attribute underneath it, so the message must NOT also travel as an attribute.
 * Saving the note therefore clears the old "Gift message" attribute, which a
 * cart started before the change may still carry (an empty value removes it).
 */
if (!customElements.get('cart-attribute')) {
  const LEGACY_GIFT_ATTRIBUTE = 'Gift message';

  customElements.define(
    'cart-attribute',
    class CartAttribute extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('input, textarea');
        if (!this.input) return;

        const isNote = this.input.name === 'note';
        const attributeName = this.input.name.replace(/^attributes\[(.*)\]$/, '$1');

        // Cart from before 2026-09-21: the message is still in the old attribute
        // and only prefills the box. Move it to the note now, without waiting for
        // the shopper to type, so the order never carries it twice.
        if (isNote && this.hasAttribute('data-migrate-legacy') && this.input.value) {
          const body = JSON.stringify({ note: this.input.value, attributes: { [LEGACY_GIFT_ATTRIBUTE]: '' } });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
            .then(() => this.removeAttribute('data-migrate-legacy'))
            .catch(() => {});
        }

        this.addEventListener(
          'input',
          debounce(() => {
            const body = JSON.stringify(
              isNote
                ? { note: this.input.value, attributes: { [LEGACY_GIFT_ATTRIBUTE]: '' } }
                : { attributes: { [attributeName]: this.input.value } }
            );
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
